<template>
  <div class="img-wrap" :style="{ width, height }" @mouseenter="show = true" @mouseleave="show = false">
    <template>
      <div :class="['img-mask', 'flex-c-ac', show ? 'fade' : '']" v-if="show">
        <a-icon class="icon mr10" type="search" @click="previewVisible = true" />
        <a-icon class="icon" type="delete" @click="handleDelete" />
      </div>
      <img class="img" :src="src" :alt="alt">
    </template>

    <!-- 图片预览 -->
    <a-modal width="40%" :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="src" />
    </a-modal>
  </div>
</template>
<script>
export default {
  props: {
    width: { type: String, default: '100px' },
    height: { type: String, default: '100px' },
    src: { type: String, default: '' },
    alt: { type: String, default: '' }
  },
  data() {
    return {
      show: false,
      previewVisible: false
    }
  },
  methods: {
    handleSearch() {
      this.$emit('search')
    },
    handleDelete() {
      this.$emit('delete')
    }
  }
}
</script>
<style lang='less'>
.img-wrap {
  position: relative;
  .img-default {
    width: 100%;
    height: 100%;
    background-color: #f5f7fa;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img {
    width: 100%;
    height: 100%;
  }
  .img-mask {
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(0, 0, 0, .5);
    .icon {
      font-size: 16px;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.85);
    }
  }
}

.fade {
  animation: fade .28s linear;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
